import { Stack } from '@mui/material';
import { NextPrevButton } from 'Components';
import { CannabisContext } from 'Context/CannabisContext';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

export const BackButton = () => {
  const { formData, setShowUploadFileArea } = useContext(CannabisContext);

  const dictionary = useDictionary(Dictionary, DICTIONARY.Reimbursements);
  const isDesktop = useIsDesktop();
  const navigate = useNavigate();

  const handleClickBack = () => {
    if (formData.invoices.length > 0) {
      setShowUploadFileArea(false);
    } else {
      navigate('/reimbursements');
    }
  };

  return (
    <Stack alignItems={'center'} mt={4}>
      <NextPrevButton
        callback={handleClickBack}
        text={dictionary.back}
        style={
          isDesktop
            ? undefined
            : {
                button: { height: '36px' },
                text: { fontSize: '16px', fontWeight: '600' },
              }
        }
      />
    </Stack>
  );
};
